// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__97gd2","border":"avatar_border__mqd5T"};